import React, { useState, useEffect, useCallback } from 'react';
import { FaWhatsapp, FaHome, FaImages } from 'react-icons/fa';
import { MdSpa, MdContactPhone } from 'react-icons/md';
import './Navbar-improved.css';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 50);

    const sections = ['home', 'services', 'gallery', 'contact'];
    const currentSection = sections.find(section => {
      const element = document.getElementById(section);
      if (element) {
        const rect = element.getBoundingClientRect();
        return rect.top <= 100 && rect.bottom >= 100;
      }
      return false;
    });

    if (currentSection) {
      setActiveSection(currentSection);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
    // Bootstrap maneja el overflow automáticamente
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    // Bootstrap maneja el overflow automáticamente
  };

  const handleNavClick = (e, href) => {
    e.preventDefault();
    closeMenu();
    
    // Smooth scroll to section
    const targetId = href.substring(1); // Remove the #
    const targetElement = document.getElementById(targetId);
    
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const navLinks = [
    { href: '#home', text: 'Inicio', icon: <FaHome /> },
    { href: '#services', text: 'Servicios', icon: <MdSpa /> },
    { href: '#gallery', text: 'Galería', icon: <FaImages /> },
    { href: '#contact', text: 'Contacto', icon: <MdContactPhone /> }
  ];

  return (
    <nav 
      className={`navbar navbar-expand-lg bg-body-tertiary ${isScrolled ? 'scrolled' : ''}`}
      role="navigation"
      aria-label="Menú principal"
    >
      <div className="container-fluid">
        <a href="#home" className="navbar-brand" onClick={(e) => handleNavClick(e, '#home')}>
          <img 
            src="/img/logo.jpg" 
            alt="Lisander Masseur Logo" 
            width="50" 
            height="50"
            className="logo-img" 
          />
          <span>Lisander Masseur</span>
        </a>

        <button 
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          onClick={toggleMenu}
          aria-expanded={isMenuOpen}
          aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div 
          className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}
          id="navbarNav"
        >
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            {navLinks.map(({ href, text, icon }) => (
              <li key={href} className="nav-item">
                <a
                  href={href}
                  onClick={(e) => handleNavClick(e, href)}
                  className={`nav-link ${activeSection === href.slice(1) ? 'active' : ''}`}
                  aria-current={activeSection === href.slice(1) ? 'page' : undefined}
                >
                  <span className="nav-icon">{icon}</span>
                  {text}
                </a>
              </li>
            ))}
          </ul>

          <a 
            href="https://wa.me/541141766377?text=¡Hola! Me interesa conocer más sobre tus servicios de masajes" 
            className="btn btn-success d-flex align-items-center gap-2"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contactar por WhatsApp"
          >
            <FaWhatsapp />
            <span>¿Te gustaría un masaje?</span>
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;